// Job roles: what someone DOES at Kyck. ONE per user, from this FIXED list
// (a code constant, not editable in the app).
//
// ⚠️ A job role is NOT access. Access is `User.role` ('admin' | 'staff') and is
// still the only thing that restricts anything. Job roles will drive dashboards,
// filters and assignment later; today they restrict nothing.

export const JOB_ROLES = [
  { key: 'account_manager_automotive', label: 'Account Manager – Automotive' },
  { key: 'account_manager_fitness', label: 'Account Manager – Fitness' },
  { key: 'design', label: 'Design' },
  { key: 'meta_ads', label: 'Meta Ads' },
  { key: 'google_ads', label: 'Google Ads' },
  { key: 'social_community', label: 'Social & Community' },
  { key: 'leadership', label: 'Leadership' },
] as const;

export type JobRole = (typeof JOB_ROLES)[number]['key'];

export const JOB_ROLE_KEYS = JOB_ROLES.map((r) => r.key) as [JobRole, ...JobRole[]];

/** What the UI prints when nobody has set one. */
export const NO_JOB_ROLE_LABEL = 'No role yet';

export function isJobRole(value: unknown): value is JobRole {
  return typeof value === 'string' && (JOB_ROLE_KEYS as readonly string[]).includes(value);
}

/** Absent, null or an unrecognised stored value all read as "no role yet". */
export function jobRoleLabel(value: string | null | undefined): string {
  const hit = JOB_ROLES.find((r) => r.key === value);
  return hit ? hit.label : NO_JOB_ROLE_LABEL;
}

export function isAccountManagerRole(value: string | null | undefined): boolean {
  return value === 'account_manager_automotive' || value === 'account_manager_fitness';
}
